import apiUrl from '../../../constants'
import axios from 'axios'
import MasterHubInfraDetails from './MasterHubInfraDetails/index.vue';

export default {
  name: 'ThermalPrinterAllocation',
  components: {
    'first': MasterHubInfraDetails,
  },
  props: [],
  data() {
    return {
      currentTab: 'First',
      componentKey: 0,
      tabs: [{
          key: 'First',
          value: 'STICKER PRINTING RESTRICTION'
        },
      ],
    }
  },
  computed: {
    currentTabComponent: function() {
      this.componentKey += 1
      return this.currentTab.toLowerCase()
    }
  },
  mounted() {},
  methods: {}
}



// WEBPACK FOOTER //
// ./src/views/components/ThermalPrinterAllocation/ThermalPrinterAllocation.js